var map = {
	"./App": 7702,
	"./App.vue": 7702,
	"./assets/css/anim.scss": 8570,
	"./assets/css/common.scss": 807,
	"./assets/css/global.scss": 3059,
	"./assets/css/reset.scss": 2841,
	"./assets/css/utils.scss": 5955,
	"./assets/fonts/bold.TTF": 7890,
	"./assets/fonts/font.css": 9399,
	"./assets/fonts/medium.TTF": 5441,
	"./assets/icons": 7258,
	"./assets/icons/": 7258,
	"./assets/icons/index": 7258,
	"./assets/icons/index.js": 7258,
	"./assets/icons/svg/icon-lfg.svg": 4012,
	"./assets/icons/svg/icon-telegram.svg": 5810,
	"./assets/images/btn-learn.png": 6902,
	"./assets/images/btn-start.png": 6502,
	"./assets/images/logo.png": 4427,
	"./assets/images/t.png": 3434,
	"./assets/images/w.jpg": 8445,
	"./assets/images/w_h.jpg": 9545,
	"./assets/js/assetsManifest": 5715,
	"./assets/js/assetsManifest.json": 5715,
	"./assets/js/noZoom": 2654,
	"./assets/js/noZoom.js": 2654,
	"./assets/js/rem": 9633,
	"./assets/js/rem.js": 9633,
	"./components/layout": 8963,
	"./components/layout.vue": 8963,
	"./components/svgIcon": 179,
	"./components/svgIcon.vue": 179,
	"./directive": 973,
	"./directive/": 973,
	"./directive/direct/v-anchor": 2828,
	"./directive/direct/v-anchor.js": 2828,
	"./directive/direct/v-copy": 4404,
	"./directive/direct/v-copy.js": 4404,
	"./directive/direct/v-debounce": 4459,
	"./directive/direct/v-debounce.js": 4459,
	"./directive/direct/v-draggable": 2971,
	"./directive/direct/v-draggable.js": 2971,
	"./directive/direct/v-scroll": 7660,
	"./directive/direct/v-scroll.js": 7660,
	"./directive/direct/v-shuibowen": 3131,
	"./directive/direct/v-shuibowen.js": 3131,
	"./directive/index": 973,
	"./directive/index.js": 973,
	"./http": 1063,
	"./http/": 1063,
	"./http/index": 1063,
	"./http/index.js": 1063,
	"./i18n": 6926,
	"./i18n/": 6926,
	"./i18n/i18nOption": 7292,
	"./i18n/i18nOption.json": 7292,
	"./i18n/index": 6926,
	"./i18n/index.js": 6926,
	"./i18n/json/Chs": 5077,
	"./i18n/json/Chs.json": 5077,
	"./i18n/json/En": 4030,
	"./i18n/json/En.json": 4030,
	"./main": 3217,
	"./main.js": 3217,
	"./mixins/anim": 2568,
	"./mixins/anim.js": 2568,
	"./router": 5092,
	"./router/": 5092,
	"./router/index": 5092,
	"./router/index.js": 5092,
	"./store": 8854,
	"./store/": 8854,
	"./store/index": 8854,
	"./store/index.js": 8854,
	"./store/modules/wallet": 9944,
	"./store/modules/wallet.js": 9944,
	"./tonWallet": 8929,
	"./tonWallet/": 8929,
	"./tonWallet/config/config": 3649,
	"./tonWallet/config/config.json": 3649,
	"./tonWallet/config_for_test/config": 6398,
	"./tonWallet/config_for_test/config.json": 6398,
	"./tonWallet/index": 8929,
	"./tonWallet/index.js": 8929,
	"./utils": 1474,
	"./utils/": 1474,
	"./utils/errcode": 8956,
	"./utils/errcode.js": 8956,
	"./utils/formatter": 3291,
	"./utils/formatter.js": 3291,
	"./utils/index": 1474,
	"./utils/index.js": 1474,
	"./view": 5624,
	"./view/": 5624,
	"./view/index": 5624,
	"./view/index.vue": 5624
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8116;